// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/wp/v4.46.579/" + "public/monaco-1903373691" + "." + __webpack_require__.h().slice(0, 10) + ".css");